import { atom } from "jotai";

/**
 * Shared state for the pointer-based "drag a series thumbnail onto a viewport
 * slot" interaction (replaces native HTML5 DnD, which Safari won't initiate on
 * a <div>). The drag controller (useSeriesPointerDrag) writes these; each
 * ProtocolViewport reads them to show its drop-target highlight.
 */

/** seriesId currently being pointer-dragged from the sidebar, or null. */
export const activeSeriesDragIdAtom = atom<string | null>(null);

/** slotId of the viewport currently under the pointer during a series drag,
 *  or null when not over any slot. */
export const seriesDragHoverSlotAtom = atom<string | null>(null);
